import React, { useState } from "react";
import { CheckCouponResult } from "../../services/firebase/checkCoupon";
import Layout from "../layout";
import SEO from "../seo";
import LoadingSpinner from "../common/loading-spinner";
import CodeCheck from "./code-check";
import CodeInvalid from "./code-invalid";
import CodeRedeem from "./redeem/code-redeem";
import CodeAlreadyUsed from "./code-already-used";
var Code = function Code() {
    var _useState = useState(""), code = _useState[0], setCode = _useState[1];
    var _useState2 = useState(CodeCheckResult.NONE), checkResult = _useState2[0], setCheckResult = _useState2[1];
    var _useState3 = useState({
        code: undefined,
        discountType: undefined,
        discountAmount: undefined,
        result: CheckCouponResult.INVALID,
        assignedArticles: undefined
    }), checkResponse = _useState3[0], setCheckResponse = _useState3[1];
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: "Gutschein- / Rabatt-Code einl\xF6sen"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "w-full border-t-8 border-solid border-makroOrange lg:w-2/3"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "text-xl lg:text-2xl text-makroOrange uppercase"
    }, "Gutschein- / Rabatt-Code einl\xF6sen"), /*#__PURE__*/ React.createElement("div", {
        className: "pb-8 px-3 lg:px-8"
    }, checkResult === CodeCheckResult.NONE ? /*#__PURE__*/ React.createElement(CodeCheck, {
        code: code,
        setCode: setCode,
        setCheckResult: setCheckResult,
        setCheckResponse: setCheckResponse
    }) : checkResult === CodeCheckResult.LOADING ? /*#__PURE__*/ React.createElement(LoadingSpinner, null) : checkResult === CodeCheckResult.VALID ? /*#__PURE__*/ React.createElement(CodeRedeem, {
        checkResponse: checkResponse
    }) : checkResult === CodeCheckResult.ALREADY_USED ? /*#__PURE__*/ React.createElement(CodeAlreadyUsed, null) : /*#__PURE__*/ React.createElement(CodeInvalid, {
        setCheckResult: setCheckResult
    })))));
};
export var CodeCheckResult;
(function (CodeCheckResult) {
    CodeCheckResult["NONE"] = "none";
    CodeCheckResult["LOADING"] = "loading";
    CodeCheckResult["INVALID"] = "invalid";
    CodeCheckResult["ALREADY_USED"] = "already_used";
    CodeCheckResult["VALID"] = "valid";
})(CodeCheckResult || (CodeCheckResult = {}));
export default Code;
